import React from 'react'
import styled from 'styled-components'
import { HtmlTextAttribute } from './HtmlTextAttribute'
import { ListAttribute } from './ListAttribute'
import { HtmlTableAttribute } from './HtmlTableAttribute'
import { TableAttribute } from './TableAttribute'
import Text from '../Text/Text'
import { SCREEN_SIZE } from '../../lib/Media'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import { DietaryListAttribute } from './DietaryListAttribute'

const Description = styled.div`
  background-color: white;
  overflow-wrap: break-word;
`

const Heading = styled.h2`
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
  color: #0d3578;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 1rem 1rem 0.375rem 1rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 0.5rem;
  }
`

const ProductComplexAttributeValue = ({
  metadata,
  onHealthierChoiceInfoPress,
}) => {
  switch (metadata.layoutType) {
    case 'DIETARY_LIST':
      return (
        <DietaryListAttribute
          metadata={metadata}
          onHealthierChoiceInfoPress={onHealthierChoiceInfoPress}
        />
      )
    case 'HTML_TEXT':
      return <HtmlTextAttribute metadata={metadata} />
    case 'LIST':
      return <ListAttribute metadata={metadata} />
    case 'HTML_TABLE':
      return <HtmlTableAttribute metadata={metadata} />
    case 'TABLE':
      return <TableAttribute metadata={metadata} />
    default:
      return null
  }
}

export const ProductComplexAttribute = ({
  metadata,
  onHealthierChoiceInfoPress,
}) => {
  return (
    <Description data-testid="productComplextAttribute">
      <Heading>
        <Text
          size="small"
          weight="black"
          color={defaultTheme.ColorBaseMineShaft500}
        >
          {metadata.name}
        </Text>
      </Heading>
      <ProductComplexAttributeValue
        metadata={metadata}
        onHealthierChoiceInfoPress={onHealthierChoiceInfoPress}
      />
    </Description>
  )
}
